<template>
  <div class="page-content">
    <div class="content-top" :style="{height:pageData.cardFrom.height}">
      <!-- 轮播图 -->
      <el-carousel style="background-color: rebeccapurple" @click.native="carouselClick" :interval="5000" arrow="always" height="100%">
        <el-carousel-item v-for="(item,index) in carouselData" :key="item.id">
          <img style="height: 100%;width: 100%" v-if="!!item.url" :src="item.url" alt=""/>
        </el-carousel-item>
      </el-carousel>
      <!-- 顶部Info -->
      <div class="top-info-content">
        <div class="top-info">
          <div style="margin-right: 10px;cursor: pointer" v-if="!pageData.logoUrl" @click="editLogo">LOGO</div>
          <el-image v-else @click="editLogo" :style="{width:pageData.logoWidth}" :src="pageData.logoUrl"></el-image>
          <div>
            <div class="project-info">
              <page-input width="250" :input.sync="pageData.projectName" :edit="edit"></page-input>
            </div>
            <div class="platform-info">
              <page-input width="250" :input.sync="pageData.platformName" :edit="edit"></page-input>
            </div>
          </div>
        </div>
        <div @click="topCenter" class="top-center">
          <span v-if="!pageData.centerData.name">中间信息</span>
          <el-image :style="{width:pageData.centerData.width}" v-if="pageData.centerData.radio === 1" :src="pageData.centerData.name"></el-image>
          <span v-if="pageData.centerData.radio === 2">{{pageData.centerData.name}}</span>
        </div>
        <div class="top-info">
          <el-tooltip v-show="edit" style="margin-right: 10px" effect="dark" content="添加" placement="bottom">
            <el-button @click="addFunctionalArea" size="small" type="primary" plain icon="el-icon-plus" circle></el-button>
          </el-tooltip>
          <div class="functional-content" v-for="(item,index) in pageData.rightFunction" :key="index">
            <div class="functional-item">
              <div class="functional-item">
                 <el-image :style="{width:item.width}" :src="item.imageUrl"></el-image>
                <div class="login-info">{{item.content}}</div>
              </div>
            </div>
          </div>
          <div class="functional-content">
            <div class="functional-item">
              <el-image style="width: 28px;" :src="require('../assets/modularMain/login-Img2.png')"></el-image>
              <div class="login-info">登录平台</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div @click.stop="functionArea" class="content-bottom-vuedraggable" :style="{height:`calc(${pageData.regionFrom.height} - 35px)`,padding:pageData.regionFrom.padding}">
      <div class="area-margin" v-for="(item,index) in pageData.list" :key="item.id" :style="{width:item.width,paddingLeft: index !== 0 ? pageData.regionFrom.margin : ''}">
        <!-- id等于1是组织机构-->
        <div @click="$event.cancelBubble = true"  v-if="item.id === 1" class="content-bottom-item org-tree-content">
          <div class="major-events-title">
            <page-input :input.sync="pageData.structure" :edit="edit"></page-input>
          </div>
          <div :class="pageData.structureList.length > 0 ? 'middle-content' : ''" class="org-tree-item-content">
            <div :style="{backgroundImage:`url(${item.imageUrl})`,backgroundSize:'cover'}" @mouseover="triangleClick(item,index)" :class="triangleIndex === index ? 'tree-item' : ''" class="org-tree-item" v-for="(item,index) in pageData.structureList" :key="index">
              <div style="color: #263b50;">{{item.content}}</div>
            </div>
            <div v-if="edit" @click="editOrganizational" class="org-tree-item">
              <i class="el-icon-plus"></i>
            </div>
          </div>
          <!-- 三角 -->
          <div class="triangle-content">
            <div class="triangle-main" :style="{right:triangleRight}">
              <div class="triangle1"></div>
              <div class="triangle2"></div>
            </div>
          </div>
          <!-- 文字描述 -->
          <div v-if="triangleIndex === 0" class="organStructure-remark">
            <p v-if="pageData.structureList.length >= 1">{{pageData.structureList[0].describe}}</p>
          </div>
          <div v-if="triangleIndex === 1" class="organStructure-remark">
            <p v-if="pageData.structureList.length >= 2">{{pageData.structureList[1].describe}}</p>
          </div>
          <div v-if="triangleIndex === 2" class="organStructure-remark">
            <p v-if="pageData.structureList.length >= 3">{{pageData.structureList[2].describe}}</p>
          </div>
        </div>
        <!-- id等于2是大事纪要 -->
        <div @click="$event.cancelBubble = true" v-if="item.id === 2" class="content-bottom-item majorEvents-content">
          <div  class="majorEvents-main">
            <div class="majorEvents-title">
              <page-input :input.sync="pageData.summaryData" :edit="edit"></page-input>
              <div class="moreMajorEvent">
                <page-input width="100" :input.sync="pageData.summaryMore" :edit="edit"></page-input>
                <i class="el-icon-arrow-right"></i>
              </div>
            </div>
            <div class="majorEvents-List">
              <div :class="{ anim: animate === true }">
                <div class="majorEvents-item" v-for="(item,index) in majorEventsList">
                  <div class="majorEvent-item-title">
                    <div class="pointStyle"></div>
                    <span>{{ item.TITLE_ }}</span>
                  </div>
                  <div class="timeStyle">{{item.CREATE_DATE}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- id等于3是应用资源 -->
        <div @click="$event.cancelBubble = true" v-if="item.id === 3" class="content-bottom-item application-resources">
          <div @mouseleave="mouseLeave(item,index)" @mouseover="btnClick(item,index)" :style="{height:applicationHeight,backgroundImage:`url(${item.imageUrl})`,backgroundSize:'cover'}" :class="applicationIndex === index ? 'application-item-hove' : ''" class="application-resources-item" v-for="(item,index) in pageData.applicationList" :key="index">
            <div style="color: #263b50;" class="application-item">
              <div :class="currentIndex === index ? 'pro-active' : ''">{{item.content}}</div>
            </div>
          </div>
          <div v-if="edit" :style="{height:applicationHeight}" class="application-resources-item add-application">
            <i @click="editApplication" class="el-icon-plus edit-application"></i>
          </div>
        </div>
        <!-- id等于4是简介和视频 -->
        <video-detail @click="$event.cancelBubble = true" v-if="item.id === 4" @operationVoid="operationVoid(item)" :voidObj="voidObj"></video-detail>
      </div>
    </div>
    <div class="bottomContent">
    </div>
    <!--添加或编辑Logo 的组件-->
    <edit-logo v-if="edit" @determine="determine" @cancel="cancel" :visible.sync="visible"></edit-logo>
    <!--中间信息-->
    <top-center v-if="edit" @determine="centerDetermine" @cancel="centerCancel" :visible.sync="centerVisible"></top-center>
    <!--增加功能区-->
    <functional-area  v-if="edit" @determineArea="determineArea" @cancelArea="cancelArea" :visible.sync="visibleArea"></functional-area>
    <!--轮播图-->
    <edit-carousel v-if="edit" :visible.sync="visibleCarousel" @getFiles="getFiles" @determine="cardDetermine" @cancel="cardCancel"></edit-carousel>
    <!--组织架构-->
    <organizational v-if="edit" @determineOrganizational="determineOrganizational" @cancelOrganizational="cancelOrganizational"  :visible.sync="visibleOrganizational"></organizational>
    <!--应用资源-->
    <application v-if="edit" @determineApplication="determineApplication" @cancelApplication="cancelApplication"  :visible.sync="visibleApplication"></application>
    <!--操作顺序-->
    <operation :radio.sync="radio" v-if="edit" @determineOperation="determineOperation" @cancelOperation="cancelOperation"  :visible.sync="visibleOperation"></operation>
    <!--获取内容模块-->
    <function-area v-if="edit" @determine="functionDetermine" @cancel="functionCancel" :visible.sync="functionVisible"></function-area>
    <div class="suspension-button">
      <div style="width: 100%;height: 100%">
        <div class="suspension save-button"><i class="el-icon-menu"></i></div>
        <div class="suspension" @click="previewEdit"><i class="el-icon-view"></i></div>
      </div>
    </div>
  </div>
</template>

<script>
// 拖动topCenter
import vuedraggable from 'vuedraggable';
// Input 组件
import pageInput from '../components/pageConfig/pageInput'
// 添加或编辑Logo 的组件
import editLogo from '../components/pageConfig/editLogo'
// top 中间信息
import topCenter from '../components/pageConfig/topCenter'
// 增加功能区
import functionalArea from '../components/pageConfig/functionalArea'
// 轮播图
import editCarousel from '../components/pageConfig/editCarousel'
// 组织架构
import organizational from '../components/pageConfig/organizational'
// 应用资源
import application from '../components/pageConfig/application'
// 项目简介
import videoDetail from '../components/pageConfig/videoDetail'
// 操作顺序
import operation from '../components/pageConfig/operation'
// 获取内容模块
import functionArea from '../components/pageConfig/functionArea'
import {getEntityName} from "../api/modularMain";
export default {
  name: "pageConfig",
  components:{
    pageInput,
    editLogo,
    functionalArea,
    editCarousel,
    organizational,
    application,
    operation,
    vuedraggable,
    videoDetail,
    functionArea,
    topCenter
  },
  data() {
    return {
      edit:true,
      visible:false,
      centerVisible:false,
      visibleArea:false,
      visibleCarousel:false,
      functionalShow:false,
      triangleIndex:0,
      triangleRight:'-12%',
      visibleOrganizational:false,
      summerData:[],
      animate:false,
      timer:null,
      majorEventsList:[
        {title:'总指挥部召开会议',time:'2022-03-26',skeletonWidth:'80'},
        {title:'开展告诉公路项目建设节后复工复产安全生产检查',time:'2022-03-26',skeletonWidth:'100'},
        {title:'公司一届七次职工代表大会',time:'2022-03-26',skeletonWidth:'86'},
        {title:'“能通全通”“互联互通”第二推进组建设',time:'2022-03-26',skeletonWidth:'70'},
        {title:'公司名称一届七次职工代表大会暨2022年度工作会议在昆召开',time:'2022-03-26',skeletonWidth:'96'},
        {title:'党委完成第二轮巡察情况反馈',time:'2022-03-26',skeletonWidth:'64'},
        {title:'举办2021年度财务决算布置暨年报审计机构进场会议',time:'2022-03-26',skeletonWidth:'86'},
        {title:'百年征程 “羽”你共进 同心共建 幸福交发',time:'2022-03-26',skeletonWidth:'78'},
        {title:'开展“宪法宣传周”系列活动',time:'2022-03-26',skeletonWidth:'92'},
        {title:'公司名称召开2021年上半年经济运行形势分析会',time:'2022-03-26',skeletonWidth:'66'},
        {title:'召开2021年度新员工入职培训',time:'2022-03-26',skeletonWidth:'74'},
      ],
      applicationIndex:0,
      visibleApplication:false,
      visibleOperation:false,
      isShowDrag: false,
      radio:1,
      current:'',
      applicationHeight:'20%',
      marginLeft:'0px',
      currentIndex:'',
      majorEventsLsit:[],
      functionVisible:false,
      voidObj:'',
      // 保存的所有数据
      pageData:{
        // Logo 地址
        imageUrl:'',
        // Logo 宽度
        imageWidth:'',
        // 项目名称
        projectName:'',
        // 平台名称
        platformName:'',
        // 轮播图高度
        cardFrom:{
          height:'60%'
        },
        // 顶部中间参数
        centerData: {},
        // 顶部右侧功能区
        rightFunction:[],
        // 组织架构标题
        structure:'',
        // 组织架构list
        structureList:[],
        // 大事纪要标题
        summaryData:'',
        // 大事纪要更多
        summaryMore:'',
        // 应用资源
        applicationList:[],
        // 顺序和功能
        list:[],
        // 功能区的区域参数
        regionFrom:{
          height:'40%'
        }
      },
      addFilesDate:{},
      // 轮播图数据啦
      carouselData:[]
    }
  },
  mounted() {
    this.timer = setInterval(this.scroll, 2000);
    // 加载轮播图
    this.getFilesSearch()
    // 获取大事纪要
    this.getSummary()
  },
  updated() {
    // console.log(this.list)
  },
  methods: {
    // 预览
    previewEdit() {
      this.edit = !this.edit
    },
    // 编辑或添加Logo
    editLogo() {
      this.visible = true
    },
    // Logo弹窗取消
    cancel() {
      this.visible = false
    },
    // Logo弹窗确定
    determine(val) {
      this.pageData.logoUrl = val.imageUrl
      this.pageData.logoWidth = val.width
      this.visible = false
    },
    topCenter() {
      this.centerVisible = true
    },
    // TOP 中间信息取消
    centerCancel() {
      this.centerVisible = false
    },
    // TOP 中间信息确定
    centerDetermine(val) {
      this.pageData.centerData = val
      this.centerVisible = false
    },
    // 添加功能区
    addFunctionalArea() {
      this.visibleArea = true
    },
    // 添加功能区取消
    cancelArea() {
      this.visibleArea = false
    },
    // 添加功能区确认
    determineArea(val) {
      this.visibleArea = false
      this.pageData.rightFunction.unshift(val)
    },
    // 点击轮播图
    carouselClick() {
      this.visibleCarousel = true
    },
    // 成功重新获取数据
    getFiles() {
      this.getFilesSearch()
    },
    cardDetermine(val) {
      this.visibleCarousel = false
      this.pageData.cardFrom = val
      console.log(this.pageData.cardFrom);
    },
    cardCancel() {
      this.visibleCarousel = false
    },
    // 获取轮播图
    getFilesSearch() {
      // let host = window.location.host;
      this.$axios.post(`/api/fs/files/search?metaData.formId=carousel202204251523tian&metaData.fileType=carousel`).then(res => {
        if (res.status === 200) {
          res.data.forEach((item,index) => {
            item.name = item.filename
            item.url = `/api/fs/files/download/${item.id}`
          })
          this.carouselData = res.data
        }
      });
    },
    // 获取功能区内容模块
    functionArea() {
      this.functionVisible = true
    },
    // 功能区内容模块弹窗取消
    functionCancel() {
      this.functionVisible = false
    },
    // 功能区内容模块弹窗确定
    functionDetermine(val,regionFrom) {
      this.pageData.list = val
      this.pageData.regionFrom = regionFrom
      this.functionVisible = false
    },
    // 三角定位
    triangleClick(item,index) {
      this.triangleIndex = index
      if(this.pageData.structureList.length === 1){
        if(index === 0){
          this.triangleRight = '-36%'
        }
      }
      if(this.pageData.structureList.length === 2){
        if(index === 0){
          this.triangleRight = '-24%'
        }else if(index ===1){
          this.triangleRight = '-50%'
        }
      }
      if(this.pageData.structureList.length === 3){
        if(index === 0){
          this.triangleRight = '-12%'
        }else if(index === 1){
          this.triangleRight = '-35%'
        }else if(index === 2){
          this.triangleRight = '-62%'
        }
      }
      if(this.pageData.structureList.length === 4){
        if(index === 0){
          this.triangleRight = '-8%'
        }else if(index === 1){
          this.triangleRight = '-28%'
        }else if(index === 2){
          this.triangleRight = '-48%'
        }else if(index === 3){
          this.triangleRight = '-68%'
        }
      }
    },
    // 组织机构弹窗
    cancelOrganizational(val) {
      this.visibleOrganizational = false
    },
    determineOrganizational(val) {
      this.visibleOrganizational = false
      this.pageData.structureList.unshift(val)
    },
    editOrganizational() {
      this.visibleOrganizational = true
    },
    operation(item) {
      this.radio = item.serial
      this.current = item.serial
      this.visibleOperation = true
    },
    // 大事纪要
    scroll() {
      this.animate = true; // 因为在消息向上滚动的时候需要添加css3过渡动画，所以这里需要设置true
      setTimeout(() => {
        //  这里直接使用了es6的箭头函数，省去了处理this指向偏移问题，代码也比之前简化了很多
        this.majorEventsList.push(this.majorEventsList[0]); // 将数组的第一个元素添加到数组的
        this.majorEventsList.shift(); //删除数组的第一个元素
        this.animate = false; // margin-top 为0 的时候取消过渡动画，实现无缝滚动
      }, 1000);
    },
    //获取大事纪要列表
    getSummary() {
      this.majorEventsList = []
      getEntityName('LOGIN_NEW_TRENDS').then((res) => {
        if (res.rows.length > 0) {
          res.rows.forEach(e => {
            if (e.fields.RELEASE_STATUS_ === 'true') {
              this.majorEventsList.push(e.fields)
            }
          })
          this.majorEventsList.sort(function (a, b) {
            return Number(a.SORT_NUM_) - Number(b.SORT_NUM_)
          })
          this.majorEventsList.forEach((item,index) => {
            if (item.TYPE_ === '1') {
              this.voidObj = item
            }
          })
          console.log(this.majorEventsList);
          // if (this.majorEventsList.length > 8) {
          //   this.timer = setInterval(this.scroll, 2000);
          // }
        }
      })
    },
    // 应用资源
    determineApplication(val) {
      console.log(val);
      // this.visibleApplication = false
      // this.pageData.applicationList.push(val)
      // if ( this.pageData.applicationList.length > 0) {
      //   let height = 1 /  this.pageData.applicationList.length * 100
      //   this.applicationHeight=`calc(${height}% )`
      // }
    },
    // 鼠标移入
    btnClick(item,index) {
      this.currentIndex = index
    },
    // 鼠标移出
    mouseLeave(item,index) {
      this.currentIndex = ''
    },
    cancelApplication() {
      this.visibleApplication = false
    },
    editApplication() {
      this.visibleApplication = true
    },
    // 操作
    determineOperation() {
      this.visibleOperation = false
      for (let i = 0; i < this.pageData.list.length; i++) {
        if (this.pageData.list[i] === this.current) {
          this.pageData.list[i] = this.radio
        }
      }
    },
    cancelOperation() {
      this.visibleOperation = false
    },
    operationVoid(item) {
      this.radio = item
      this.current = item
      this.visibleOperation = true
    },
    unique(arr) {
      const res = new Map();
      return arr.filter((arr) => !res.has(arr.id) && res.set(arr.id, 1));
    },
  }
}
</script>

<style scoped lang="less">

.page-content {
  width: 100%;
  height: 100%;
}
.toolbar {
  padding: 10px;
  box-sizing: border-box;
}
.content-top {
  position: relative;
}
.top-center:hover {
  cursor: pointer;
}
.content-bottom {
  //height: 40%;
  //padding: 20px;
  display: flex;
  box-sizing: border-box;
  justify-content: center;
}
.content-bottom  span {
  display: flex;
}
.content-bottom-vuedraggable {
  box-sizing: border-box;
  width: 100%;
  display: flex;
  justify-content: center;
}
.bottom-vuedraggable-item {
  display: flex;
  justify-content: center;
}
.content-bottom-item {
  //margin-left: 10px;
}
.el-carousel {
  height: 100%;
}
.top-info-content {
  flex: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: absolute;
  top: 0;
  z-index: 999;
  width: 100%;
  background-color: #ffffffc2;
  padding: 10px 20px;
  box-sizing: border-box;
}
.top-info {
  display: flex;
  align-items: center;
}
.top-info .el-image {
  margin-right: 8px;
  cursor: pointer;
}
.functional-content {
  display: flex;
  align-items: center;
  margin-left: 10px;
}
.functional-content:nth-child(2) {
  margin-left: 0;
}
.functional-item {
  display: flex;
  align-items: center;
}
.add-icon {
  font-size: 35px;
  cursor: pointer;
  color: #1296db;
  margin-right: 5px;
}
.project-info {
  color:#333333;
  font-size: 17px;
  letter-spacing: 1.8px;
  cursor: pointer;
}
.platform-info {
  font-size: 22px;
  font-weight: 600;
  color:#333333;
  cursor: pointer;
}
.login-info {
  font-size: 14px;
  cursor: pointer;
}
.org-tree-content {
  height: 100%;
  width: 100%;
  padding: 15px;
  border: 1px solid #eaeaea;
  border-radius: 5px;
  font-size: 14px;
  box-sizing: border-box;
}
.org-tree-item-content {
  display: flex;
}
.middle-content {
  justify-content: center;
}
.org-tree-item {
  width: 20%;
  height: 40px;
  padding: 15px 10px;
  margin: 0 5px;
  background-color: #f2f2f2;
  border-radius: 5px;
  text-align: center;
  cursor: pointer;
  line-height: 50px;
}
.organStructure-item-main {
  margin: 0 auto;
}
.tree-item {
  background-color: #a9d4fe;
}
.triangle-content{
  border-bottom: 1px solid #dbd8d8;
  .triangle-main{
    position: relative;
    display: inline-block;
    top: 4px;
  }
  .triangle1{
    width: 0;
    border-top: 10px solid transparent;
    border-right: 10px solid transparent;
    border-bottom: 10px solid #dbd8d8;
    border-left: 10px solid transparent;
  }
  .triangle2{
    width: 0;
    border-top: 10px solid transparent;
    border-right: 10px solid transparent;
    border-bottom: 10px solid #fff;
    border-left: 10px solid transparent;
    position: absolute;
    top: 1px;
    z-index: 9;
  }
}
.organStructure-remark{
  font-size: 12px;
  color: #5d5d5d;
  margin-top: 10px;
  text-decoration: underline;
  cursor: pointer;
  line-height: 1.7;
}
.major-events-title{
  display: flex;
  align-items: center;
  font-weight: 600;
  margin-bottom: 10px;
  background-color: #fff;
  justify-content: space-between;
}
.summary-content {
  height: 100%;
  width: 30%;
  border: 1px solid #eaeaea;
  border-radius: 5px;
  padding: 15px;
  font-size: 14px;
  box-sizing: border-box;
}
.summary-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.majorEvents-content{
  //width: 100%;
  height: 100%;
  border: 1.5px solid #eaeaea;
  border-radius: 5px;
  // padding: 17px 0px;
  padding: 15px;
  font-size: 14px;
  //margin: 0 8px;
  box-sizing: border-box;
  .majorEvents-title{
    display: flex;
    align-items: center;
    font-weight: 600;
    margin-bottom: 10px;
    z-index: 9;
    background-color: #fff;
    justify-content: space-between;
  }
  .majorEvents-item{
    display: flex;
    justify-content: space-between;
    padding: 5px 0px;
    border-bottom: 1px solid #f4f4f4;
    width: 100%;
    cursor: pointer;

  }
  .timeStyle{
    line-height: 22px;
    color: #999;
  }
  .majorEvents-main{
    width: 100%;
    height: 100%;
  }
  .majorEvents-List{
    width: 100%;
    height: 85%;
    overflow: hidden;
  }
  /*滚动条样式*/
  .majorEvents-List::-webkit-scrollbar {
    width: 2px;
    /*height: 4px;*/
  }
  .majorEvents-List::-webkit-scrollbar-thumb {
    border-radius: 20px;
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.026);
    background: rgba(0, 0, 0, 0.026);
  }
  .majorEvents-List::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.026);
    border-radius: 20px;
    background: rgba(0, 0, 0, 0.016);

  }
  .majorEvent-item-title{
    width: 80%;
    display: flex;
    align-items: center;
    span{
      color: #5d5d5d;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
    }
  }

  .majorEvents-item:hover{
    .majorEvent-item-title{
      span{
        color: #000000;
        font-weight: 600;
      }

    }
    .pointStyle{
      background-color: #3680ff;
    }
  }
  .pointStyle{
    width: 5px;
    height: 5px;
    display: inline-block;
    background-color: #e5e5e5;
    border-radius: 10px;
    margin-right: 8px;
  }
}
.moreMajorEvent{
  display: flex;
  align-items: center;
  right: 1px;
  cursor: pointer;
}
.pointStyle{
  width: 5px;
  height: 5px;
  display: inline-block;
  background-color: #e5e5e5;
  border-radius: 10px;
  margin-right: 8px;
}
.timeStyle{
  line-height: 22px;
  color: #999;
}
.application-resources {
  height: 100%;
  width: 100%;
  display: flex;
  flex-flow: column;
  justify-content: space-between;
}
.application-resources-item:hover {
  background-color: #fff;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,0.2);
}
.application-resources-item {
  width: 100%;
  //height: 25%;
  border: 1px solid #eaeaea;
  border-radius: 5px;
  font-size: 14px;
  box-sizing: border-box;
  margin-top: 10px;
}

.application-resources-item:nth-child(1) {
  margin-top: 0;
}
.application-resources-item {
  cursor: pointer;
}
.edit-application {
  margin-right: 20px;
}
.edit-application:hover {
  color: #409EFF;
}
.add-application {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  color: #999999;
}
.bottomContent{
  position: absolute;
  //padding: 10px 0px;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  bottom: 1px;
  text-align: center;
  width: 100%;
  background-color: rgb(7,66,134);
  box-sizing: border-box;
  .bottomContent-text{
    display: inline-block;
    font-size: 12px;
    color: #fff;
    white-space: pre-wrap;
  }
  .bottomContent-img{
    width: 67px;
    position: relative;
    top: 5px;
    margin-right: 10px;
  }
}
.application-item {
  display: flex;
  align-items: center;
  height: 100%;
  margin-left: 20px;
  font-size: 18px;
  color: #2e3442;
  font-weight: 600;
}
.transition-item {
  box-sizing: border-box;
}
.transition-item:nth-child(1) {
  padding-left: 0;
}
.currency {
  width: 40%;
}
.application-resources-style {
  width: 20%;
}
.pro-active {
  margin-left: 20px;
}
.suspension-button {
  position: fixed;
  bottom: 100px;
  right: 20px;
  z-index: 9999;
  height: 100px;
  width: 50px;
  background-color: #e6eaf0;
  margin: 0 auto;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}
.save-button {
  display: block;
  margin-bottom: 20px;
}
.suspension {
  height: 50%;
}
.suspension:hover {
  color: #ffffff;
  cursor: pointer;
  background-color: red;
}
</style>



// WEBPACK FOOTER //
// src/views/pageConfig.vue